import { Navigate, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { GenerateAsoListWrapper } from './aso-generate-list/GenerateAsoList'
import { SignAsoListWrapper } from './aso-sign-list/SignAsoList'

const AtendimentosAsoPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route
        path='assinar'
        element={
          <>
            <PageTitle description={t('pagina.assinarAso.descricao')}>Assinar ASO's</PageTitle>
            <SignAsoListWrapper />
          </>
        }
      />
      <Route
        path='gerar'
        element={
          <>
            <PageTitle description={t('pagina.gerarAso.descricao')}>Gerar ASO's</PageTitle>
            <GenerateAsoListWrapper />
          </>
        }
      />
      <Route index element={<Navigate to='/apps/atendimentosAso/assinar' />} />
    </Routes>
  )
}

export default AtendimentosAsoPage
